import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable()
export class PublicApiUrlInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.url.startsWith('/api')) {
      return next.handle(
        request.clone({
          url: this._withPublicApi(request.url),
        }),
      );
    }

    return next.handle(request);
  }

  private _withPublicApi(url: string) {
    const normalizedUrl = url.replace('/api', '');
    return new URL(normalizedUrl, environment.apiUlr).toString();
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/interceptors/public-api-url.interceptor.ts